module.exports = __webpack_public_path__ + "img/scale.5d84b42f.png";